// src/context/provider/signal-context-provider.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from "react";
var defaultSignalManager = {
  // eslint-disable-next-line no-void
  publish: function () {
    return void 0;
  },
  subscribe: function subscribe(topic, SignalType, callbacks) {
    return {
      SignalType: SignalType,
      // eslint-disable-next-line no-void
      unsubscribe: function () {
        return void 0;
      }
    };
  },
  // eslint-disable-next-line no-void
  unsubscribe: function () {
    return void 0;
  }
};
var SignalContext = React.createContext({
  manager: defaultSignalManager
});
var SignalContextProvider = function (param) {
  var children = param.children,
    manager = param.manager;
  var memoizedManager = React.useMemo(function () {
    return {
      manager: manager
    };
  }, [manager]);
  return /* @__PURE__ */React.createElement(SignalContext.Provider, {
    value: memoizedManager
  }, children);
};
SignalContextProvider.displayName = "SignalContextProvider";
// src/context/hooks/use-signal-publisher.ts
import React3 from "react";
// src/context/hooks/use-signal-context.ts
import React2 from "react";
var useSignalContext = function () {
  return React2.useContext(SignalContext);
};
// src/context/hooks/use-signal-publisher.ts
var useSignalPublisher = function () {
  var manager = useSignalContext().manager;
  var memoizedPublish = React3.useMemo(function () {
    return {
      publish: function publish(signal) {
        if (typeof window !== "undefined") {
          manager.publish(signal);
        }
      }
    };
  }, []);
  return memoizedPublish;
};
// src/context/hooks/use-signal-subscriber.ts
import React4 from "react";
var useSignalSubscriber = function (topic, SignalType, callbacks) {
  var manager = useSignalContext().manager;
  var subscriptionRef = React4.useRef();
  var callbacksRef = React4.useRef(callbacks);
  if (callbacks !== callbacksRef.current) {
    callbacksRef.current = callbacks;
  }
  if (typeof window !== "undefined") {
    if (!subscriptionRef.current) {
      subscriptionRef.current = manager.subscribe(topic, SignalType, _object_spread_props(_object_spread({}, callbacksRef.current || {}), {
        onSuccess: function (signal, subscription) {
          var _callbacksRef_current_onSuccess, _callbacksRef_current;
          return (_callbacksRef_current = callbacksRef.current) === null || _callbacksRef_current === void 0 ? void 0 : (_callbacksRef_current_onSuccess = _callbacksRef_current.onSuccess) === null || _callbacksRef_current_onSuccess === void 0 ? void 0 : _callbacksRef_current_onSuccess.call(_callbacksRef_current, signal, subscription);
        },
        onError: function (signal, error) {
          var _callbacksRef_current_onError, _callbacksRef_current;
          return (_callbacksRef_current = callbacksRef.current) === null || _callbacksRef_current === void 0 ? void 0 : (_callbacksRef_current_onError = _callbacksRef_current.onError) === null || _callbacksRef_current_onError === void 0 ? void 0 : _callbacksRef_current_onError.call(_callbacksRef_current, signal, error);
        }
      }));
    }
  } else {
    subscriptionRef.current = {
      SignalType: SignalType,
      unsubscribe: function unsubscribe() {}
    };
  }
  React4.useEffect(function () {
    if (!subscriptionRef.current) {
      subscriptionRef.current = manager.subscribe(topic, SignalType, _object_spread_props(_object_spread({}, callbacksRef.current || {}), {
        onSuccess: function (signal, subscription) {
          var _callbacksRef_current_onSuccess, _callbacksRef_current;
          return (_callbacksRef_current = callbacksRef.current) === null || _callbacksRef_current === void 0 ? void 0 : (_callbacksRef_current_onSuccess = _callbacksRef_current.onSuccess) === null || _callbacksRef_current_onSuccess === void 0 ? void 0 : _callbacksRef_current_onSuccess.call(_callbacksRef_current, signal, subscription);
        },
        onError: function (signal, error) {
          var _callbacksRef_current_onError, _callbacksRef_current;
          return (_callbacksRef_current = callbacksRef.current) === null || _callbacksRef_current === void 0 ? void 0 : (_callbacksRef_current_onError = _callbacksRef_current.onError) === null || _callbacksRef_current_onError === void 0 ? void 0 : _callbacksRef_current_onError.call(_callbacksRef_current, signal, error);
        }
      }));
    }
    return function () {
      var _subscriptionRef_current;
      (_subscriptionRef_current = subscriptionRef.current) === null || _subscriptionRef_current === void 0 ? void 0 : _subscriptionRef_current.unsubscribe();
      subscriptionRef.current = void 0;
    };
  }, []);
  return subscriptionRef.current;
};
export { SignalContextProvider, useSignalPublisher, useSignalSubscriber };